module.exports = __webpack_public_path__ + "static/media/torso-low-back.ed85f12e.png";